import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { memo } from "react";
import { ANNOTATION_INDICATOR, COMMENT_METADATA_CONTAINER } from "~/constants/testIDs";
export const discussionMetadata = tailwindVariants({
    base: "relative mr-1 inline-flex min-h-[12px] min-w-[12px]",
    variants: {
        color: {
            blue: "text-blue-9",
            grey: "text-grey-9"
        }
    },
    defaultVariants: {
        color: "grey"
    }
});
export const DiscussionMetadata = /*#__PURE__*/ memo((param)=>{
    let { color, text, Icon, textTestId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: discussionMetadata({
            color
        }),
        "data-testid": COMMENT_METADATA_CONTAINER,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "absolute",
                "data-testid": ANNOTATION_INDICATOR,
                style: {
                    top: !!text ? 3 : 0
                },
                children: !!Icon && /*#__PURE__*/ _jsx(Icon, {
                    className: "size-3"
                })
            }),
            !!text && /*#__PURE__*/ _jsx("div", {
                className: "ml-4 text-14 text-inherit",
                "data-testid": textTestId,
                children: text
            })
        ]
    });
});
DiscussionMetadata.displayName = "DiscussionAnnotationInfo";
